import { render } from "./Login.vue?vue&type=template&id=5f3870f6&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=5f3870f6&lang=less&scoped=true"

import exportComponent from "E:\\Object\\xin_poc_mini\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3870f6"]])

export default __exports__